import { useCallback, useEffect, useRef, useState } from 'react';
import { apiService } from '../../../../services/apiService';
import { fetchJobImportDigest } from '../services/jobImportReportService';

const POLL_MS = 60000;

async function handleSessionExpired() {
    await apiService.postRequest('/auth/logout');
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = '/login';
}

export function useJobImportDigest(params = {}) {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const requestIdRef = useRef(0);
    const paramsKey = JSON.stringify(params);

    const runFetch = useCallback(async () => {
        const requestId = ++requestIdRef.current;
        setLoading(true);
        setError(null);
        try {
            const response = await fetchJobImportDigest(JSON.parse(paramsKey));
            if (requestId !== requestIdRef.current) return;

            if (response?.success) {
                setData(response.data);
            } else if (response?.authenticate === false) {
                await handleSessionExpired();
            } else {
                setError(response?.message || 'Unable to load import digest');
            }
        } catch (e) {
            if (requestId === requestIdRef.current) {
                setError('Unable to load import digest');
            }
        } finally {
            if (requestId === requestIdRef.current) {
                setLoading(false);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paramsKey]);

    useEffect(() => {
        runFetch();
        const timer = setInterval(runFetch, POLL_MS);
        return () => clearInterval(timer);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paramsKey]);

    return { data, loading, error, refetch: runFetch };
}
